/* global G */
import { curry } from 'lib/util'
import redirectSequence from '@gaia/sequence/module/adapter/router/redirect'
import routeComposition from '@gaia/trait/composition/route'

/**
 * To Static Event Handler
 *
 * Behaves like the `redirect` event handler, but passes the `ref` defined in
 * `route` as `key` to the action.
 *
 * If `component` has an `url` option, opens it in a new tab instead of
 * redirecting to an action.
 *
 * MAYBE: Generalize this event handler in `app/_shared/events/redirect` ?
 *
 * @param {Gaia.AppModule.Spec} module          app module
 * @param {Gaia.Component} component            ui component
 * @param {Gaia.AppModule.EventHandler} event   incoming event
 * @returns {Promise<void>}
 */
const toStatic = async (module, component, event) => {
  try {
    const { detail } = event
    const moduleState = module[G.STATE]
    const { route, options: { url } } = component[G.CONFIGURATION]

    if (url) {
      await module[G.ADAPTER][G.ROUTER].newTab({ url })
    } else {
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)
      await redirectSequence(module)({ detail, key: route?.ref })
    }
  } catch (e) {
    console.error(e)
  }
}

export default curry(toStatic)
